import { DateRange } from '@cast/shared-types';
import { getRangeLength } from '@cast/utils';

import { getCostReportGranularity } from 'features/cost-report/utils/granularity';
import { DataGranularity } from 'types/cost-report';

export const getReliabilityGranularity = (
  range: DateRange
): DataGranularity => {
  const hoursInRange = getRangeLength(range, 'hours');

  if (hoursInRange <= 6) {
    return { step: 1, unit: 'minutes' };
  }

  return getCostReportGranularity(range);
};
